export default 'height=400, width=550, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0';